import React, {useCallback} from "react";
import {IPlayer} from "modules/types";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getIsDisabledAddToTeam, getIsPlayerInTeam} from "modules/selectors";
import {addPlayerToTeam, removePlayerFromTeam} from "modules/actions";
import {Button} from "./common";

interface IActions {
	player: IPlayer;
	closeHandler: () => void;
	isDisabled: boolean;
}

export const AllStarPlayerModalActions: React.FC<IActions> = ({
	player,
	closeHandler,
	isDisabled,
}) => {
	const dispatch = useDispatch();
	const {t} = useTranslation();
	const isPlayerInTeam = useSelector(getIsPlayerInTeam)(player.id);
	const isAddDisabled = useSelector(getIsDisabledAddToTeam)(player);
	const isSwapEnabled = !isPlayerInTeam && isAddDisabled;

	const addHandler = useCallback(() => {
		dispatch(addPlayerToTeam({playerId: player.id, position: player.position}));
		closeHandler();
	}, [dispatch, player, closeHandler]);

	const removeHandler = useCallback(() => {
		dispatch(removePlayerFromTeam(player.position));
		closeHandler();
	}, [dispatch, player, closeHandler]);

	const handleSwap = useCallback(() => {
		removeHandler();
		addHandler();
		closeHandler();
	}, [removeHandler, addHandler, closeHandler]);

	if (isPlayerInTeam) {
		return (
			<Button onClick={removeHandler} disabled={isDisabled}>
				{t("player.modal.remove")}
			</Button>
		);
	}

	if (isSwapEnabled) {
		return (
			<Button onClick={handleSwap} disabled={isDisabled}>
				{t("player.modal.swap")}
			</Button>
		);
	}

	return (
		<Button onClick={addHandler} disabled={isAddDisabled}>
			{t("player.modal.add")}
		</Button>
	);
};
